import { Form, setAxiosInstance } from '@/services/form';
import { APPSTORE_URLS } from '@/api/app-store/urls';

const formAppCreate = {
    name: '',
    category_id: '',
};

export const state = {
    app: null,
    appSolicitations: null,
    reviews: [],
    apps: [],
    formAppCreate: new Form(formAppCreate),
    loading: false,
    error: null,
};

export const getters = {
    app: (state) => state.app,
    appSolicitations: (state) => state.appSolicitations,
    lastAppSolicitation: (state) => state.appSolicitations?.solicitations.find((s) => s.application_version_id === state.app.latest_version.id) ?? {},
    apps: (state) => state.apps,
    formAppCreate: (state) => state.formAppCreate,
    loading: (state) => state.loading,
    error: (state) => state.error,
};

export const mutations = {
    SET_APP(state, app) {
        state.app = app;
        state.reviews = [];
    },
    SET_SOLICITATIONS(state, solicitations) {
        state.appSolicitations = solicitations;
    },
    SET_APPS(state, apps) {
        state.apps = apps;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    UPDATE_VERSION(state, payload) {
        state.app.latest_version = payload;
    },
    UPDATE_PUBLISHED_VERSION(state, payload) {
        state.app.published_version = payload;
    },
    SET_REVIEWS(state, reviews) {
        state.reviews = reviews;
    },
    UPDATE_REVIEW_IN_LIST(state, updatedReview) {
        const idx = state.reviews.findIndex((review) => review.id === updatedReview.id);
        if (idx !== -1) {
            state.reviews.splice(idx, 1, updatedReview); // Mutate array in place
        }
    },
};

export const actions = {
    async createApp({ commit }) {
        commit('SET_LOADING', true);

        setAxiosInstance(import.meta.env.VITE_API_APPSTORE_URL);

        try {
            const response = await state.formAppCreate.post(APPSTORE_URLS.APP.CREATE);
            commit('SET_APP', response.data.data);
        } finally {
            commit('SET_LOADING', false);
        }
    },

    setApp({ commit }, appData) {
        commit('SET_APP', appData);
    },

    setApps({ commit }, apps) {
        commit('SET_APPS', apps);
    },

    setSolicitations({ commit }, payload) {
        commit('SET_SOLICITATIONS', payload);
    },

    updateAppVersion({ commit }, payload) {
        commit('UPDATE_VERSION', payload);
    },

    updatePublishedVersion({ commit }, payload) {
        commit('UPDATE_PUBLISHED_VERSION', payload);
    },

    setReviews({ commit }, payload) {
        commit('SET_REVIEWS', payload);
    },

    updateReviewInList({ commit }, updatedReview) {
        commit('UPDATE_REVIEW_IN_LIST', updatedReview);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
